module.exports = __webpack_public_path__ + "img/ltktopshared-1x.c175e7d.jpg";